import React from "react";
import PropTypes from "prop-types";
import TooltipButton from "../tooltip-button";

const FooterButtons = ({ page, totalPages, setPage }) => {
  const pagesButtons = [];
  pagesButtons.push(
    <TooltipButton
      key="first_page"
      tooltipPosition="bottom"
      buttonClassName={`footer-button icon ${page === 1 ? "disabled" : ""}`}
      disabled={page === 1}
      onClick={() => setPage(page - 1)}
      iconClassName="icono-arrow-left-simple"
      tooltipText="Ir a la página anterior"
    />
  );

  const pageNumbers = [page];

  if (page > 1) pageNumbers.unshift(page - 1);
  if (page < totalPages) pageNumbers.push(page + 1);

  if (page > 4) {
    pageNumbers.unshift(1, "...");
  } else if (page > 3) {
    pageNumbers.unshift(1, 2);
  } else if (page > 2) {
    pageNumbers.unshift(1);
  }

  if (page < totalPages - 3) {
    pageNumbers.push("...", totalPages);
  } else if (page < totalPages - 2) {
    pageNumbers.push(totalPages - 1, totalPages);
  } else if (page < totalPages - 1) {
    pageNumbers.push(totalPages);
  }

  pageNumbers.forEach(number => {
    pagesButtons.push(
      <TooltipButton
        key={`${number}_page`}
        tooltipPosition="bottom"
        buttonClassName={`footer-button ${number === "..." ? "dots" : "number"} ${
          number === page ? "selected" : ""
        }`}
        disabled={number === "..." || number === page}
        onClick={() => setPage(number)}
        buttonText={number}
        tooltipText={`Ir a pagina ${number}`}
      />
    );
  });

  pagesButtons.push(
    <TooltipButton
      key="last_page"
      tooltipPosition="bottom"
      buttonClassName={`footer-button icon ${page === totalPages ? "disabled" : ""}`}
      disabled={page === totalPages}
      onClick={() => setPage(page + 1)}
      iconClassName="icono-arrow-right-simple"
      tooltipText="Ir a la página siguiente"
    />
  );

  return (
    <div id="paginationButtons" className="table-buttons">
      {pagesButtons}
    </div>
  );
};

FooterButtons.propTypes = {
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired
};

export default FooterButtons;
